import BaseCommand from "../BaseCommand";

export default class UpdateRetentionPolicyCommand extends BaseCommand {
  public isEnabled: boolean;
  public inactivityThresholdDays: number;

  constructor(isEnabled: boolean, inactivityThresholdDays: number) {
    super();
    this.isEnabled = isEnabled;
    this.inactivityThresholdDays = inactivityThresholdDays;
  }

  public override isUpdate(): boolean {
    return true;
  }

  public getEndpoint(): string {
    return "auth/retention-policy";
  }
}